<script setup>
import {useModalBus} from '@/core/composables/useModalBus';
import {RMAlert} from 'redmine-ui-kit';

const {closeModal} = useModalBus();

const props = defineProps({
    isActive: {
        type: Boolean,
        default: false,
    },
    modalData: {
        required: true,
        validator(prop) {
            return typeof prop === 'object' || prop === null;
        },
    },
});
</script>

<template>
    <RMAlert
        :visibility="props.isActive"
        v-bind="props.modalData"
        @close="closeModal(props.modalData.template)"
    />
</template>
